// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB6U_pH8joKYc37m1pZf7vN80VK3oEem7Y",
  authDomain: "autinneurodiversa.firebaseapp.com",
  projectId: "autinneurodiversa",
  storageBucket: "autinneurodiversa.firebasestorage.app",
  messagingSenderId: "206932609539",
  appId: "1:206932609539:web:67cedb9dffe48af0275c36"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };